import { SeoLandingLayout, SeoLandingPageData } from '../../../components/SeoLandingLayout';

const data: SeoLandingPageData = {
  seo: {
    title: 'Prévision de trésorerie simple : méthode facile sans expert | Trezoone',
    description: 'Une méthode simple pour faire votre prévision de trésorerie sans être expert financier. 3 étapes, 30 minutes, résultats concrets.',
    canonical: '/prevision-tresorerie-simple',
    keywords: 'prévision trésorerie simple, trésorerie facile, prévision trésorerie débutant, méthode trésorerie simple',
  },
  hero: {
    tag: 'Prévision trésorerie simple',
    title: 'Votre prévision de trésorerie en 3 étapes — sans jargon, sans expert.',
    subtitle: 'Pas besoin d\'être expert-comptable. La prévision de trésorerie, c\'est une question de bon sens et d\'organisation. Voici la méthode.',
    ctaLabel: 'Commencer simplement',
  },
  pilierLink: { label: 'Prévision de trésorerie', href: '/prevision-tresorerie' },
  sections: [
    {
      type: 'explain',
      title: 'La méthode en 3 étapes simples',
      content: 'Pour faire une prévision de trésorerie simple, il faut répondre à 3 questions :',
      items: [
        'Étape 1 : Combien j\'ai maintenant ? → votre solde bancaire actuel',
        'Étape 2 : Qu\'est-ce qui va rentrer dans les 3 prochains mois ? → ventes prévues, subventions, aides',
        'Étape 3 : Qu\'est-ce qui va sortir dans les 3 prochains mois ? → salaires, charges fixes, fournisseurs',
        'Résultat : Solde actuel + Recettes prévues - Dépenses prévues = Solde dans 3 mois',
      ],
    },
    {
      type: 'example',
      title: 'Application concrète : une boulangerie artisanale',
      content: 'Situation : solde actuel 8 000 €, CA mensuel stable 15 000 €, charges mensuelles 12 000 €.',
      items: [
        'Janvier : +15 000 € encaissements - 12 000 € charges → +3 000 €',
        'Février : +15 000 € - 12 000 € charges - 3 500 € loyer annuel → -500 €',
        'Mars : +15 000 € - 12 000 € charges → +3 000 €',
        'Résultat : solde en mars = 8 000 + 3 000 - 500 + 3 000 = 13 500 €',
        'Alerte : février légèrement négatif → vérifier si le loyer annuel coïncide bien ce mois-là',
      ],
    },
    {
      type: 'midcta',
      title: 'En 30 minutes, construisez votre première prévision de trésorerie — sans expert, sans jargon',
      content: 'Trezoone guide chaque étape : solde actuel, recettes prévues, dépenses à venir. Résultat : votre prévision sur 12 mois, automatiquement mise à jour.',
    },
    {
      type: 'solution',
      title: 'Trezoone fait ces 3 étapes automatiquement',
      content: 'Trezoone répond aux mêmes 3 questions — mais en se connectant à votre banque et en utilisant vos données réelles.',
      items: [
        'Solde actuel : synchronisé depuis votre banque',
        'Recettes prévues : saisies une fois, réutilisées automatiquement',
        'Dépenses prévues : détectées depuis votre historique bancaire',
        'Résultat : prévision sur 12 mois, mise à jour automatiquement',
      ],
    },
    {
      type: 'cluster',
      title: 'Démarrer simplement avec la trésorerie',
      links: [
        { label: 'Prévision de trésorerie', href: '/prevision-tresorerie' },
        { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
        { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
        { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
        { label: 'Tableau trésorerie gratuit', href: '/tableau-tresorerie-gratuit' },
        { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
        { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
        { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
      ],
    },
    {
      type: 'cta',
      title: 'La prévision de trésorerie n\'a jamais été aussi simple',
      content: 'Testez Trezoone. 14 jours offerts. Opérationnel en 30 minutes.',
    },
  ],
  relatedLinks: [
    { label: 'Prévision de trésorerie', href: '/prevision-tresorerie' },
    { label: 'Plan de trésorerie', href: '/plan-tresorerie' },
    { label: 'Gestion trésorerie TPE', href: '/gestion-tresorerie-tpe' },
    { label: 'Modèle plan trésorerie', href: '/modele-plan-tresorerie' },
    { label: 'Tableau trésorerie gratuit', href: '/tableau-tresorerie-gratuit' },
    { label: 'Excel vs logiciel trésorerie', href: '/excel-vs-logiciel-tresorerie' },
    { label: 'Alerte trésorerie', href: '/alerte-tresorerie' },
    { label: 'Gestion trésorerie', href: '/gestion-tresorerie' },
  ],
};

interface Props { onNavigate?: (p: string) => void; onSignIn?: () => void; onSignUp?: () => void; }
export default function TresorerieSimplePage({ onNavigate, onSignIn, onSignUp }: Props) {
  return <SeoLandingLayout data={data} onNavigate={onNavigate} onSignIn={onSignIn} onSignUp={onSignUp} />;
}
